import { OnboardingStudents } from '@/components/molecules/Admin/Onboarding/Students'
import { useAppSelector } from '@/store/hooks'

export function Onboarding() {
	const {
		matriculate: { classSelect },
		auth: { user },
	} = useAppSelector((state) => state)

	const findOnboarding = user?.onboarding_all?.find(
		(onboading) => onboading.curso_id === classSelect?.curso_id
	)

	if (findOnboarding?.nivel_onboarding) {
		return (
			<div className='flex w-full border-b border-gray-50/10 md:border-none'>
				<OnboardingStudents />
			</div>
		)
	}

	return <></>
}
